import angular from 'angular';
import { ArticulosPaginationComponent } from './articulosPagination';

export default angular.module('pizzutoAutopartes.articulosPagination', [])
    .component(ArticulosPaginationComponent.selector, ArticulosPaginationComponent)
    .name;



// WEBPACK FOOTER //
// ./client/components/articulos-pagination/index.js